var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"use-common"},[_c('div',{staticClass:"activity_ends flex_box_column"},[_c('img',{staticClass:"activity_ends_icon",attrs:{"src":require("../assets/activityendsicon.png"),"alt":""}}),_c('span',{staticClass:"activity_ends_text"},[_vm._v("活动已经结束了哦～")])])])
}]

export { render, staticRenderFns }